import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularComics() {
  const popular = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              人气排行
            </h2>
            <p className="text-sm text-foreground-500 mt-2">千万读者共同选择</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          {popular.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <span className={`w-6 h-6 flex items-center justify-center rounded font-bold text-xs shrink-0 ${
                  index < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-500'
                }`}>
                  {index + 1}
                </span>
                <div className="w-10 h-14 rounded overflow-hidden shrink-0">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫排行榜`}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                </div>
              </div>

              <div className="hidden sm:flex items-center gap-6 shrink-0">
                <span className="text-xs text-foreground-500">{comic.category === 'romance' ? '恋爱' : comic.category === 'fantasy' ? '奇幻' : comic.category === 'action' ? '动作' : comic.category === 'thriller' ? '悬疑' : comic.category === 'comedy' ? '搞笑' : comic.category === 'drama' ? '剧情' : comic.category === 'daily' ? '日常' : comic.category === 'school' ? '校园' : '恐怖'}</span>
                <span className="text-xs text-foreground-500">{(comic.views / 10000).toFixed(0)}万阅读</span>
                <span className="flex items-center gap-0.5 text-xs text-accent-600">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[10px]"></i>
                  </span>
                  {comic.rating}
                </span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  comic.status === '连载中' ? 'bg-secondary-100 text-secondary-700' : 'bg-background-200 text-foreground-500'
                }`}>
                  {comic.status}
                </span>
              </div>

              <span className="w-5 h-5 flex items-center justify-center text-foreground-400 shrink-0">
                <i className="ri-arrow-right-s-line text-sm"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}